import { render, staticRenderFns } from "./FishingYearSelector.vue?vue&type=template&id=6a6e4bfc&"
import script from "./FishingYearSelector.vue?vue&type=script&lang=js&"
export * from "./FishingYearSelector.vue?vue&type=script&lang=js&"
import style0 from "./FishingYearSelector.vue?vue&type=style&index=0&id=6a6e4bfc&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports